import { faBell, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PointerDiv from "./PointerDiv";
import { useEffect, useState } from "react";
import useNotificationMessageService from "../../../../hooks/useNotificationMessageService";
import UserNotificationModal from "../../../modal/Notification/UserNotificationModal";

interface NotificationsButtonProps {
  notificationsEnabled: boolean;
}

const NotificationButton = ({
  notificationsEnabled,
}: NotificationsButtonProps) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const notificationMessageService = useNotificationMessageService();

  const markAsRead = (ids: string[]) => {
    setShowNotificationModal(false);
    if (!notificationsEnabled) return;

    notificationMessageService.markAsRead(ids).then(() => {
      notificationMessageService.getUnreadCount().then((result) => {
        setUnreadCount(result.data);
      });
    });
  };

  useEffect(() => {
    if (!notificationsEnabled) return;
    notificationMessageService
      .getUnreadCount()
      .then((result) => {
        setUnreadCount(result.data);
      })
      .catch((error) => {});
  }, [notificationsEnabled, notificationMessageService]);

  useEffect(() => {
    if (notificationsEnabled && unreadCount > 0) {
      setShowNotificationModal(true);
    }
  }, [notificationsEnabled, unreadCount]);

  return (
    <>
      {" "}
      <PointerDiv
        showPointer={false}
        onClick={() => setShowNotificationModal(true)}
        className="pe-auto d-flex flex-row align-items-center gap-1 mb-1 px-1"
      >
        <FontAwesomeIcon
          icon={unreadCount > 0 ? faCircleExclamation : faBell}
          color="white"
          size="lg"
        />
        <span className="mt-1 mr-2 text-white">
          Notifications ({unreadCount})
        </span>
      </PointerDiv>
      {notificationsEnabled && showNotificationModal && (
        <UserNotificationModal
          show={showNotificationModal}
          onClose={() => setShowNotificationModal(false)}
          totalUnreadCount={unreadCount}
          markRead={markAsRead}
        />
      )}
    </>
  );
};

export default NotificationButton;
